<template>
  <div id="filter-buttons-wrapper" class="filter-buttons-wrapper">
    <div class="filters">
      <div class="filter-buttons">
        <OpeningType
          v-if="openingType"
          :section="openingType"
        />
        <FilterButtonGroupSize
          v-if="groupSize && byArrangementSelected"
          :section="groupSize"
        />
        <FilterButtonDaysOpen
          v-if="daysOpen"
          :section="daysOpen"
          :showLeftIcon="true"
          :disableFilters="disableFilters"
        />
        <FilterButtonDistance v-show="searchTypeValue !== 'garden'" />
      </div>
      <div class="tag-buttons">
        <TagPills/>
      </div>
    </div>
    <div class="filter-buttons-wrapper__chevron-container">
      <font-awesome-icon
        class="filter-buttons-wrapper__chevron-container--icon"
        :icon="['far', 'chevron-right']"
        @click="handleChevronClick"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import OpeningType from '@/components/header/filters/OpeningType'
import FilterButtonDistance from '@/components/header/filters/FilterButtonDistance'
import FilterButtonDaysOpen from '@/components/header/filters/FilterButtonDaysOpen'
import FilterButtonGroupSize from '@/components/header/filters/FilterButtonGroupSize'
import TagPills from '@/components/header/filters/TagPills'

export default {
  name: 'FilterButtons',

  components: {
    OpeningType,
    FilterButtonDistance,
    TagPills,
    FilterButtonDaysOpen,
    FilterButtonGroupSize,
  },

  computed: {
    ...mapGetters('filter', [
      'dynamicFilterSectionByKey',
      'filterTypeByArray',
      'sectionFilterSelected',
    ]),
    ...mapGetters('garden', [
      'searchTypeValue',
    ]),

    tags() {
      return this.dynamicFilterSectionByKey('basic')
    },
    daysOpen() {
      return this.dynamicFilterSectionByKey('days_open')
    },
    groupSize() {
      return this.dynamicFilterSectionByKey('group_size')
    },
    openingType() {
      return this.dynamicFilterSectionByKey('opening_type')
    },

    byArrangementSelected() {
      return this.sectionFilterSelected('opening_type') === 'by-arrangement'
    },

    disableFilters() {
      return this.$route.name === 'Garden'
    },
  },
  methods: {
    handleChevronClick() {
      const scrollWrapper = document.querySelector('.filters');

      if (scrollWrapper) scrollWrapper.scrollLeft = 2500;
    },
  },
}
</script>

<style lang="scss">
.filter-buttons-wrapper {
  position: relative;
  justify-content: space-between;
  display: flex;
  align-items: center;

  &__chevron-container {
    display: none;
    cursor: pointer;

    @media (max-width: 1200px) {
      display: block;

      &--icon {
        margin: 0 0 0 10px;
      }
    }
  }

  .filters {
    display: flex;
    gap: 11px;
    overflow: auto;

    @media (max-width: 1200px) {
      overflow-x: scroll;
      -ms-overflow-style: none;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    .filter-buttons {
      display: flex;
      gap: 11px;
    }

    .tag-buttons {
      .tag-buttons-wrapper {
        display: flex;
        border-left: 1px solid white;
        gap: 0.5rem;
        padding: 0 0.5rem;

        > button {
          width: max-content;
        }
      }
    }
  }

  .filter-sidebar {
    display: flex;
    margin-left: auto;
    padding-right: 16px;
    padding-left: 16px;
    top: 0;
    right: -16px;

    .filter-sidebar-wrapper {
      width: 125px;
    }
    @include media-breakpoint-down(md) {
      display: none;
    }
  }
  .dropdown-close {
    display:none;
    @include media-breakpoint-down(lg) {
      display:flex;
      float: right;
      border: none;
      background: transparent;
      font-size: 0.8em;
    }

  }

}
</style>
